import { RefObject, useEffect } from 'react';

const HUBSPOT_SCRIPT_LOAD_DELAY = 200;
const SCRIPT_REGEX = /<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/i;

export function useHubSpotFormInjection(containerRef: RefObject<HTMLDivElement>, formHtmlCode: string, isMounted: boolean) {
	useEffect(() => {
		if (!containerRef.current || !isMounted || !formHtmlCode) return;

		const hasScripts = SCRIPT_REGEX.test(formHtmlCode);

		const timer = setTimeout(() => {
			if (!containerRef.current) return;

			if (hasScripts) {
				const fragment = document.createRange().createContextualFragment(formHtmlCode);
				const scripts = Array.from(fragment.querySelectorAll('script'));
				const [initScript, renderScript] = scripts;

				scripts.forEach((s) => s.remove());
				containerRef.current.appendChild(fragment);

				if (initScript) {
					initScript.defer = true;
					containerRef.current.appendChild(initScript);

					if (renderScript) {
						initScript.onload = () => {
							if (!containerRef.current) return;
							renderScript.defer = true;
							renderScript.async = true;
							containerRef.current.appendChild(renderScript);
						};
					}
				}
			} else {
				containerRef.current.innerHTML = formHtmlCode;
			}
		}, HUBSPOT_SCRIPT_LOAD_DELAY);

		return () => clearTimeout(timer);
	}, [formHtmlCode, isMounted]);
}
